import type { AiAutocompletePlugin } from './aiAutocompletePluginType';
import { createAiAutocompletePlaceholderControllerPlugin } from './pm-plugins/placeholder-controller/placeholder-controller-plugin';
import { acceptSuggestionCommand, dismissSuggestionCommand } from './ui/components/commands';
import { createPlugin } from './ui/components/main';

export const aiAutocompletePlugin: AiAutocompletePlugin = ({ api }) => ({
	name: 'aiAutocomplete',
	commands: {
		acceptSuggestion: (params) => acceptSuggestionCommand(params, api?.analytics?.actions),
		dismissSuggestion: () => dismissSuggestionCommand(api?.analytics?.actions),
	},
	pmPlugins() {
		return [
			{
				name: 'aiAutocompletePlugin',
				plugin: () => createPlugin(api),
			},
			{
				name: 'ai-autocomplete-placeholder-controller',
				plugin: () => createAiAutocompletePlaceholderControllerPlugin({ api }),
			},
		];
	},
});
